/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".host_a3f87333{display:inline}\n"}]);
export const host = "host_a3f87333";